function isImageFile(file) {
  return Boolean(file?.type?.startsWith("image/"));
}

function loadImageFromFile(file) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Invalid image"));
    };
    img.src = url;
  });
}

function loadImageFromDataUrl(dataUrl) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("Invalid image"));
    img.src = dataUrl;
  });
}

function canvasToWebpBlob(canvas, quality) {
  return new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob), "image/webp", quality);
  });
}

async function compressImageElement(img, maxBytes) {
  const w = img.width || 0;
  const h = img.height || 0;
  if (!w || !h) throw new Error("Invalid image dimensions");
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  canvas.width = w;
  canvas.height = h;
  ctx.drawImage(img, 0, 0, w, h);

  let quality = 0.92;
  let blob = await canvasToWebpBlob(canvas, quality);
  while (blob && blob.size > maxBytes && quality > 0.1) {
    quality -= 0.06;
    blob = await canvasToWebpBlob(canvas, quality);
  }

  if (!blob) throw new Error("Could not compress image");
  return blob;
}

export async function compressImageFile(file, maxBytes = Number.MAX_SAFE_INTEGER) {
  if (!file || !isImageFile(file)) return file;
  const img = await loadImageFromFile(file);
  const blob = await compressImageElement(img, maxBytes);
  const name = `${String(file.name || "image").replace(/\.[^.]+$/, "")}.webp`;
  return new File([blob], name, { type: "image/webp" });
}

export async function compressUserPhoto(file) {
  return compressImageFile(file, Number.MAX_SAFE_INTEGER);
}

export async function compressPhoto(file) {
  return compressImageFile(file, Number.MAX_SAFE_INTEGER);
}

export async function compressAttachmentIfImage(file) {
  if (!isImageFile(file)) return file;
  return compressPhoto(file);
}

export async function compressDataUrl(dataUrl, maxBytes = Number.MAX_SAFE_INTEGER) {
  if (!dataUrl || typeof dataUrl !== "string") return dataUrl;
  const img = await loadImageFromDataUrl(dataUrl);
  const blob = await compressImageElement(img, maxBytes);
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("Could not read compressed image"));
    reader.readAsDataURL(blob);
  });
}
